import { css } from "@emotion/core";
import { DWEB_HEADER_HEIGHT, FONTS, BG_BASE, BOX_SHADOW_COLOR } from "shared/styles/base";

export const headerCss = css`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: ${BG_BASE};
    z-index: 10;
`;

export const headerBlockStyle = css`
    font: 500 1rem ${FONTS.CERA};
    color: #666;
    display: flex;
    align-items: center;
    box-shadow: 0 1px 0 0 ${BOX_SHADOW_COLOR};
    height: ${DWEB_HEADER_HEIGHT}px;
    padding: 0 30px;

    .header-logo-svg {
        fill: #231f20;
    }

    .header-categories {
        display: flex;
        flex: 1;
        height: 100%;
        align-items: center;
        margin-left: 48px;
    }

    .header-actions {
        padding-left: 48px;
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        font-family: ${FONTS.CERA};
        font-size: 1rem;
        color: #000;
        list-style: none;
        align-items: center;
    }

    .action {
        cursor: pointer;
        margin-left: 38px;
        font-weight: 400;

        &:first-of-type {
            margin-left: 0;
        }
    }
`;
